/* globals $, globalScene, allTweens, controller */
import { TimelineMax, Strong } from 'gsap';
import 'gsap/ScrollToPlugin';

import ScrollMagic from 'helpers/importers/ScrollMagic';

export default function newsScene () {

  let tween = new TimelineMax()
    .from($('#news > .wrapper h2'), 0.5, {
      xPercent: -120,
      opacity: 0,
      ease: Strong.easeOut,
    })
    .from($('#news > .wrapper .view-news'), 0.5, {
      yPercent: 100,
      opacity: 0,
      ease: Strong.easeOut,
    });

  allTweens.push(tween);

  let sceneStart = new ScrollMagic.Scene({
    triggerElement: '#news',
    offset: 100,
    duration: 0,
    triggerHook: 'onEnter',

  });

  let scene = new ScrollMagic.Scene({
    triggerElement: '#news',
    offset: 200,
    duration: 0,
    triggerHook: 'onEnter',
  })
  .setTween(tween);

  sceneStart.enabled(false);
  scene.enabled(false);

  sceneStart.addTo(controller);
  scene.addTo(controller);

  globalScene.push(sceneStart);
  globalScene.push(scene);
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/scenes/newsScene.js